import React, { useState } from "react";
import OpportunitySlider from "./OpportunitySlider";
import PriceDetails from "./PriceDetails";
import PricesAndOffersHeader from "./PricesAndOffersHeader";
import VillaStats from "./VillaStats";

const PricesSection = ({ villa, randomInt }) => {
  const [currency, setCurrency] = useState("tl");
  const [days, setDays] = useState("night");
  return (
    <div id="prices" className="flex flex-col">
      <div className="flex mb-2 lg:hidden">
        <VillaStats views={randomInt} recentViews="24 saat" />
      </div>
      <PricesAndOffersHeader
        villa={villa}
        currency={currency}
        setCurrency={setCurrency}
        days={days}
        setDays={setDays}
      />
      <PriceDetails villa={villa} currency={currency} days={days} />
      <OpportunitySlider villa={villa} />
    </div>
  );
};

export default PricesSection;
